import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";

// Pages
import HomePage from "./pages/HomePage";
import WhatWeDoPage from "./pages/WhatWeDoPage";
import WhoWeServePage from "./pages/WhoWeServePage";
import WhyHeritagePage from "./pages/WhyHeritagePage";
import AboutPage from "./pages/AboutPage";
import HomeCareGuidePage from "./pages/HomeCareGuidePage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";

// Scroll restoration component
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash, scroll to that element with offset
    if (hash) {
      const timeoutId = setTimeout(() => {
        const elementId = hash.slice(1);
        const element = document.getElementById(elementId);
        if (element) {
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
      return () => clearTimeout(timeoutId);
    } else {
      // Scroll to top when navigating to a page without hash
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App" data-testid="app-root">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/what-we-do" element={<WhatWeDoPage />} />
            <Route path="/who-we-serve" element={<WhoWeServePage />} />
            <Route path="/why-heritage" element={<WhyHeritagePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/home-care-guide" element={<HomeCareGuidePage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
